import React from "react";
import Icons from "../Icons";
import moment from "moment";

export const RegistrationSuccessHeaderWithPreModeration = (
    {
        eventName,
        email,
        $locale,
        hideAcceptedTitle,
        acceptedTitle,
        hideAcceptedSubtitle,
        acceptedSubtitle,
        children
    }
) => (
    <div className="auth-container">
        <p className="icon-container accent">
            <Icons name="success" />
        </p>
        {!hideAcceptedTitle && (
            <h1>{acceptedTitle || $locale.get('auth.login.email.success.title.premoderation', {eventName: eventName})}</h1>
        )}
        {!hideAcceptedSubtitle && (
            <p>{acceptedSubtitle || $locale.get('auth.login.email.success.premoderation', {email: email})}</p>
        )}
        {children}
    </div>
)

export const RegistrationSuccessHeaderNow = ({
    email,
    $locale,
    hideSuccessTitle,
    successTitle,
    hideSuccessSubtitle,
    successSubtitle,
    children
}) => (
    <>
        <p className="icon-container accent">
            <Icons name="success" />
        </p>
        {!hideSuccessTitle && (
            <h1>{successTitle || $locale.get('auth.login.email.success.title.withoutPremoderation')}</h1>
        )}
        {!hideSuccessSubtitle && (
            successSubtitle
                ? <p>{successSubtitle}</p>
                : <p dangerouslySetInnerHTML={{__html: $locale.get('auth.login.email.success.subtitle', {email: email})}} />
        )}
        <div>
            <h2 className="auth-internal-subtitle">
                {$locale.get('auth.login.submit')}
            </h2>
            {children}
        </div>
    </>
)

export const RegisteredSuccessHeaderBefore = ({$locale, children, hideInfoBlock, email}) => {
    const Heading = hideInfoBlock ? 'h1' : 'h2';

    return (
        <>
            <Heading>{$locale.get('auth.login.email.success.title')}</Heading>
            <span>{$locale.get('auth.login.email.success.subtitle.password')}</span>
            {children}
        </>
    );
};

export const RegistrationSuccessHeader = ({
    email,
    isRegisteredNow,
    $locale,
    children,
    hideSuccessTitle,
    successTitle,
    hideSuccessSubtitle,
    successSubtitle,
    hideInfoBlock,
}) => {
    if (isRegisteredNow) {
        return (
            <RegistrationSuccessHeaderNow
                email={email}
                $locale={$locale}
                hideSuccessTitle={hideSuccessTitle}
                successTitle={successTitle}
                hideSuccessSubtitle={hideSuccessSubtitle}
                successSubtitle={successSubtitle}
            >
                {children}
            </RegistrationSuccessHeaderNow>
        );
    }

    return (
        <RegisteredSuccessHeaderBefore
            $locale={$locale}
            email={email}
            hideInfoBlock={hideInfoBlock}
        >
            {children}
        </RegisteredSuccessHeaderBefore>
    );
}

export const RegistrationHeader = ({$locale, hideInfoBlock, children}) => {
    const Heading = hideInfoBlock ? 'h1' : 'h2';

    return (
        <>
            <Heading>{$locale.get('auth.login.registrationTitle')}</Heading>
            {children}
        </>
    );
}

export const RegistrationHeaderName = ({
    $locale,
    eventName,
    customDescription = '',
    hideLoginSubtitle,
    authRequired,
    hasRegistrationFields,
    hideInfoBlock,
    children,
}) => {
    return (
        <>
            {(hideInfoBlock || !authRequired)
                ? <h1>{eventName}</h1>
                : <h2>
                    {$locale.get(hasRegistrationFields
                        ? 'auth.login.registrationTitle'
                        : 'auth.login.title.onlyEnter')
                    }
                </h2>
            }
            {!hideLoginSubtitle && 
                <div className="email-request-header">
                    <p>{!!customDescription
                        ? customDescription
                        : $locale.get(authRequired
                            ? hasRegistrationFields ? 'auth.login.subtitle.require.register' : 'auth.login.subtitle.require.auth'
                            : 'auth.login.subtitle.authNotRequire.name')
                        }
                    </p>
                </div>
            }
            {children}
        </>
    );
}

export const EmailRequestHeader = ({
    $locale,
    eventName,
    timeStart,
    customDescription = '',
    hideLoginSubtitle,
    enterOnly,
    hideInfoBlock,
    authRequired,
    children,
}) => {
    const eventTimeStart = moment.unix(timeStart).format('LLL') + ' (UTC' + moment.unix(timeStart).format('Z') + ')';
    const subtitleRequiredAuth = enterOnly ? 'auth.login.subtitle.require.auth.enterOnly' : 'auth.login.subtitle';

    return (
        <>
            {(hideInfoBlock || !authRequired)
                ? <h1>{eventName}</h1>
                : <h2>{$locale.get(enterOnly ? 'broadcast.auth.participation-select.login-title' : 'auth.login.title.enterOrRegister')}</h2>
            }
            {(hideInfoBlock || !hideLoginSubtitle) && (
                <div className="email-request-header">
                    {(hideInfoBlock && authRequired) &&
                        <p>{$locale.get('ticketAuth.timeStart', {datetime: eventTimeStart})}</p>
                    }
                    {!hideLoginSubtitle && (
                        <p>{customDescription || $locale.get(authRequired ? subtitleRequiredAuth : 'auth.login.subtitle.authNotRequire.email')}</p>
                    )}
                </div>
            )}
            {children}
        </>
    );
}
